import React from "react"

import { useTabBarTabContainerDraggableViewModel } from "../model/useTabBarTabContainerDraggableViewModel"
import { TabBarBaseTab } from "./TabBarBaseTab"
import type { TabBarTabProps } from "./TabBarTab"

export const TabBarSortableTab = React.memo(
  React.forwardRef<HTMLDivElement, TabBarTabProps>((props, ref) => {
    const { dndRef, dndListeners, isDragging, insertBefore, insertAfter } =
      useTabBarTabContainerDraggableViewModel({
        eventKey: props.eventKey,
        index: props.index,
        label: props.label,
        isDragDisabled: props.isDragDisabled,
        dragSourceData: props.dragSourceData,
        disabled: props.disabled
      })

    return (
      <TabBarBaseTab
        {...props}
        ref={ref}
        dndRef={dndRef}
        dndListeners={dndListeners}
        isDragging={isDragging}
        insertBefore={insertBefore}
        insertAfter={insertAfter}
        isSortable
      />
    )
  })
)

TabBarSortableTab.displayName = "TabBar.SortableTab"
